export enum AuthorizationStatus {
  AwaitingApproval = 'Awaiting Approval',
  Approved = 'Approved',
  Declined = 'Declined'
}
